import styled from 'styled-components'
import { Button } from './Button.style'
import { CenteredContainer } from './Common.style'
import { Img } from './Img.style'
import { LSimpleText } from './Text.style'
import { LSectionDescription } from './Containers.style'

export const FileCard = styled(CenteredContainer)`
    margin-top: 20px;
    
    &.is-in-multi-card {
        margin-top: 0;
    }
`

export const FileInputs = styled(CenteredContainer)`
    padding: 15px 32px;

    &.LINEAR {
        padding: 0;
        display: none;
    }
`

export const FileInput = styled.input`
    position: relative;
    text-align: right;
    opacity: 0;
    z-index: 2;
    cursor: pointer;
    //height: 46px;
    max-width: 200px;

    &.LINEAR {
        display: none;
    }
`

export const ButtonFileInput = styled.button`
    font-family: "Medium";
    cursor: pointer;
    color: #fff;
    background-color: #3079c9;
    font-size: 17px;
    text-transform: uppercase;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.4rem;
    border: none;
    outline: none;
    text-align: center;
    text-decoration: none;
    border-radius: 0px;
    line-height: 49px;
    svg {
        color: #fff;
        font-size: 20px
    }
`
export const FileListTitle = styled.p`
    font-family: "Bold";
    color: #3079c9;
    text-transform: uppercase;
    font-size: 1rem;

    &.LINEAR {
        display: none;
    }
`
export const FileList = styled.ul`
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    flex-wrap: wrap;
    
    &.LINEAR {
        display: grid;
        align-items: center;
        justify-content: stretch;
        width: 100%;
        border-radius: 12px;
        padding: 15px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        //width: unset;
        //gap: 20px;
        //grid-template-columns: 1fr 1fr;  /* Due colonne uguali */

        &.none {
            display: none;
        }

        &.is-in-multi-card {
            box-shadow: none;
            padding: 0;
        }
    }

    &.foto-list-camera-upload {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        width: auto;

        .file-item {
            border: none;
            width: unset;
            height: unset;
            justify-self: start;
            .file-item-preview-img-content {
                width: 134px;
                height: 130px;
                border: none;
                border-radius: 16px;
                overflow: hidden;
            }
        }
    }
`

export const FileListItem = styled.li`
    list-style: none;
    width: 100px;
    height: 124px;
    border: 2px solid #3079c9;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &.LINEAR {
        &.file-item {
            width: 100%;
            max-width: 100%;
            overflow: hidden;
            height: 190px;
            border: none;
            > div:nth-child(1) {
            width: 100%;
            overflow: hidden;
            border-radius: 24px;
            border: 1px solid #3c7b35;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                display: block;
            }
            }
            > div:nth-child(2) {
                margin-top: 10px;
                margin-bottom: 10px;
            }
        }
    }
`

export const FileItemContent = styled(CenteredContainer)`
    display: block;
    height: 100%;
    display: block;
    display: flex;
    justify-content: center;
    align-items: center;
`
export const LFileNameAndBinContainer = styled(LSectionDescription)`
    display: flex;
    justify-content: space-between;
`

export const LFileNameText = styled(LSimpleText)`
    max-width: calc(100% - 32px);
    overflow-x: hidden;
    white-space: nowrap;
    overflow: hidden; 
    text-overflow: ellipsis;
`

export const FileActionButton = styled(Button)`
    cursor: pointer;
    background-color: transparent;
    height: 32px;
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
`

export const FilePreviewImg = styled(Img)`
    /* height: 100%; */
    width: 100%;
    object-fit: cover;
    height: 100%;
`

export const FilePreviewIconContainer = styled.div`
    svg {
        font-size: 56px;
        color: rgb(48, 121, 201);
    }
    &.LINEAR {
        svg {
            color: rgb(60, 123, 53);
        }
    }
`

export const FileFullPageImageContainer = styled(CenteredContainer)`
    z-index: 9;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.8);
`

export const FileFullPageImage = styled(FilePreviewImg)`
    position: absolute;
    top: 50%;
    transform: translatey(-50%);
    width: 90%;
    height: auto;
`

export const FullPageCloseBtn = styled(Button)`
    cursor: pointer;
    position: fixed;
    top: 4rem;
    right: 2rem;
    color:#fff;
    font-size: 2.2rem;
    background-color: transparent;
    width: 48px;
    height: 48px;
`

export const FullPageDeleteBtn = styled(FullPageCloseBtn)`
    left: 2rem;
    z-index: 99;
`
export const ResizerContainer = styled.div`
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 12px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: #FFF;
    color: #0F3250;
`
export const DeletePhotoContainer = styled.div<any>`
    cursor: pointer;
    padding: 12px 0 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 50%;
    background-color: #FFF;
    color: #0F3250;
    font-family: Medium;
    text-decoration: underline;
    letter-spacing: 0.4px;
`

export const FileCtaContainer = styled(DeletePhotoContainer)`
    display: none;
    &.is-in-file-list {
        display: flex;
    }
`

export const CameraPreviewImgContainer = styled.div`
    width: 100%;
    max-height: 10px;
    overflow: hidden;
    opacity: 0;
    transition: max-height 0.4s ease-in, opacity 0.3s ease-in;

    &.is-loaded {
        max-height: 100vh;
        opacity: 1;
    }
`

export const CameraFileFullPageImage = styled(FilePreviewImg)`
    width: 100%;
    height: auto;
`

export const SectionCameraFotoContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;
`

export const CameraMiniaturePhotoContainer = styled.div`
    width: 64px;
    height: 64px;
    background-color: #3F3F3F;
    border-radius: 8px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
`

export const CameraMiniatureBadgeItem = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(45%, -45%);
    width: 28px;
    height: 28px;
    background-color: #5393BC;
    color: #FFF;
    border-radius: 60px;
    font-size: 16px;

    display: flex;
    justify-content: center;
    align-items: center;
`

export const FileMultiContainer = styled.div<{ $adaptingDoubleLine?: boolean }>`
    width: 100%;
    display: flex;
    gap: 24px;
    border-radius: 12px;
    padding: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

    ${({ $adaptingDoubleLine }) => $adaptingDoubleLine && `
        flex-direction: column;
        gap: 20px;
    `}
`

export const FileItemContainer = styled.div`
    flex: 1;
`

export const FileItemTitle = styled.p`
    color: #3D3D3D;
    line-height: 20px;
    font-family: "Bold";
    margin-bottom: 16px;
`



